const endpoint =
  'https://zlr000t7g7.execute-api.us-east-1.amazonaws.com/production/stripe';
export default endpoint;
